import { useMutation } from "react-query";
import { addTexasGrouping } from "../../../../../actions/Utilities/TexasGrouping";

const useAddTexasGrouping = () => {
  return useMutation(addTexasGrouping);
};
export default useAddTexasGrouping;
